import moment from 'moment'

const SERVICE_DAY_START_HOUR = 5

// API의 날짜 전용 값은 기존 계약대로 사용자의 로컬 시계를 기준으로 계산한다.
// UTC로 변환하면 오전 5시 경계와 서버에 보내는 YYYY-MM-DD 값이 달라질 수 있다.

export function getServiceMoment(value) {
  const current = value === undefined ? moment() : moment(value)
  return current.clone().subtract(SERVICE_DAY_START_HOUR, 'hours')
}

export function getServiceDate(value) {
  return getServiceMoment(value).format('YYYY-MM-DD')
}

export function isBeforeServiceDayStart(value) {
  const current = value === undefined ? moment() : moment(value)
  return current.hour() < SERVICE_DAY_START_HOUR
}

export function getServiceYear(value) {
  return getServiceMoment(value).format('YYYY')
}

export function isCurrentServiceDate(date, now) {
  return date === getServiceDate(now)
}

export function getServiceDayBounds(date) {
  const startOn = moment(date, 'YYYY-MM-DD', true)
    .startOf('day')
    .hour(SERVICE_DAY_START_HOUR)

  return {
    startOn,
    endOn: startOn.clone().add(1, 'day'),
  }
}

export function getNextServiceDayStart(value) {
  const current = value === undefined ? moment() : moment(value)
  const nextStart = current.clone()
    .startOf('day')
    .hour(SERVICE_DAY_START_HOUR)

  if (!current.isBefore(nextStart)) nextStart.add(1, 'day')
  return nextStart
}

export function getMillisecondsUntilNextServiceDay(value) {
  const current = value === undefined ? moment() : moment(value)
  return Math.max(0, getNextServiceDayStart(current).diff(current))
}
